export const SUPER_ADMIN = 'Super admin'
export const TOURNAMENT_ADMIN = 'Tournament admin'
export const TOURNAMENT_MANAGER = 'Tournament manager'
